module.exports = __webpack_public_path__ + "ilustracao-carro.svg";